<div [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}">
    <div class="info">
        <p><strong>{{("ORG.ACR.CREDENTIALS_TITLE" | translate)}}</strong></p>
        <p>{{("ORG.ACR.PROCESS_INFO" | translate)}}</p>
        <p>{{("ORG.ACR.USAGE_INFO" | translate)}}</p>
    </div>
    <div class="inner-content">
        <div>
            <button mat-raised-button (click)=generateOrganizationToken() *ngIf="!tokenExist">{{ ("ORG.ACR.GENERATE_CREDENTIALS"  | translate) }}</button>
            <button mat-raised-button (click)=toogleShowCredentials() *ngIf="tokenExist">{{ ("ORG.ACR.GET_CREDENTIALS" | translate) }}</button>
            <br/>
        </div>
        <div *ngIf="tokenExist && showToken" class="token-inputs">
            <div>
                <input id="tokenUsername" type="text" matTooltip="Token Username" matTooltipPosition="above" readonly [value]="acrTokenUsername" class="token-input-field">
                <input id="tokenUsername" type="text" matTooltip="Token Password" matTooltipPosition="below" readonly [value]="acrTokenPassword" class="token-input-field">
            </div>
        </div>
    </div>
</div>
<mat-divider></mat-divider>